import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SCUIContent } from '../../atomic/organisms';
import UserOrderDetailsCard from './components/UserOrderDetails/UserOrderDetailsCard';
import UserOrderProductDetail from './components/UserOrderProductDetails/UserOrderProductDetail';
import { useTranslation } from 'react-i18next';
import { Grid, CircularProgress } from '@mui/material';
import { SCUINoRecordComponent } from '../../atomic/atoms';
import NotFoundV3 from '../../assets/icons/svg/pageIcons/NotFoundV3.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrderDetails, getReturnDetails } from '../../stores/redux/actions';
import { OD } from './orderDetail.classes';
import { fetchOrderInformation } from './components/UserOrderDetails/components/AddressInformationCard/addressInformationCard.helpers';

function OrderDetail() {
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();
    const search = location.search;
    const searchParams = new URLSearchParams(search);

    const [orderId, setOrderId] = useState<number>();
    const [orderNumber, setOrderNumber] = useState<number>();
    const [shippingListNo, setShippingListNo] = useState<number>();
    const [trackingCode, setTrackingCode] = useState<string>();
    const [orderInformation, setOrderInformation] = useState<any>(undefined);

    const { data, loading }: any = useSelector((state: any) => state.orderDetails);
    const [shippingListId, setShippingListId] = useState<number>(data?.shippingListId);

    const loadOrderInformation = useCallback(async () => {
        if (!data?.customerId || !data?.orderNumber) {
            return;
        }
        try {
            const info = await fetchOrderInformation(data);
            setOrderInformation(info);
        } catch {
            setOrderInformation(null);
        }
    }, [data]);

    useEffect(() => {
        let req: any = { cultureCode: 'tr-TR' };
        let orderIdParameter = Number(searchParams.get('OrderId')) || Number(searchParams.get('orderId'));
        let orderNumberParameter = Number(searchParams.get('OrderNumber')) || Number(searchParams.get('orderNumber'));
        let shippingListIdParameter =
            Number(searchParams.get('ShippingListId')) || Number(searchParams.get('shippingListId'));
        let shippingListNoParameter =
            Number(searchParams.get('ShippingListNo')) || Number(searchParams.get('shippingListNo'));
        let trackingCodeParameter = searchParams.get('TrackingCode') || searchParams.get('trackingCode');
        if (orderIdParameter) {
            req.orderId = orderIdParameter;
            setOrderId(Number(orderIdParameter));
        } else if (shippingListIdParameter) {
            req.shippingListId = shippingListIdParameter;
            setShippingListId(shippingListIdParameter);
        } else if (orderNumberParameter) {
            req.orderNumber = orderNumberParameter;
            setOrderNumber(orderNumberParameter);
        } else if (shippingListNoParameter) {
            req.shippingListNo = shippingListNoParameter;
            setShippingListNo(shippingListNoParameter);
        } else if (trackingCodeParameter) {
            req.trackingCode = trackingCodeParameter;
            setTrackingCode(trackingCodeParameter);
        }
        dispatch(fetchOrderDetails(req));
    }, []);

    useEffect(() => {
        if (data && data.orderId) {
            let request = { orderId: data.orderId };
            dispatch(getReturnDetails(request));
        }
    }, [data?.orderId]);

    useEffect(() => {
        loadOrderInformation();
    }, [loadOrderInformation]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (data?.orderId) {
                const targetElement = document.querySelector(`.shippingListNo-${shippingListNo}`);
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    targetElement.classList.add('swipeBackgroundBlue');
                }
            }
        }, 2000);
        const removeClassTimeout = setTimeout(() => {
            const targetElement = document.querySelector(`.shippingListNo-${shippingListNo}`);
            if (targetElement) {
                targetElement?.classList.remove('swipeBackgroundBlue');
            }
        }, 5000);

        return () => {
            clearTimeout(timeoutId);
            clearTimeout(removeClassTimeout);
        };
    }, [data?.orderId, shippingListNo]);

    if (loading) {
        return (
            <Grid
                className={OD.loadingGrid}
                container
                style={{ height: '100%' }}
                alignItems="center"
                justifyContent="center"
            >
                <div
                    className={OD.loadingInner}
                    style={{
                        textAlign: 'center',
                        position: 'relative',
                        pointerEvents: 'none',
                    }}
                >
                    <CircularProgress size={80} />
                </div>
            </Grid>
        );
    }
    return data?.orderNumber ? (
        <SCUIContent>
            {data?.orderNumber && (orderId || shippingListId || orderNumber || shippingListNo || trackingCode) && (
                <div className={OD.detailsWrap} style={{ marginRight: '3rem' }}>
                    <UserOrderDetailsCard
                        datas={data}
                        orderInformation={orderInformation}
                        onRefreshOrderInformation={loadOrderInformation}
                    />
                    <UserOrderProductDetail datas={data} orderInformation={orderInformation} />
                </div>
            )}
        </SCUIContent>
    ) : (
        <div className={OD.noRecordWrap}>
            <SCUINoRecordComponent
                img={NotFoundV3}
                text={t('orderDetail.orderNotfound') + `: ${orderNumber || shippingListNo || trackingCode || ''}`}
            ></SCUINoRecordComponent>
        </div>
    );
}

export default OrderDetail;
